import React from 'react'
import { Box, Divider, Paper, Skeleton, Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ApiTableSkeleton, BarChartSkeleton } from '@e3dc-react/shell/Elements/Skeletons'

const useStyles = makeStyles()(theme => ({
  divider: {
    borderColor: theme.palette.divider,
  },
  cardStats: {
    marginTop: theme.spacing(2),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  cardSkeleton: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  filterSkeleton: {
    borderRadius: theme.spacing(theme.shape.borderRadius),
    height: 36,
    width: 100,
  },
}))

const EMobilityChargingSessionsSkeletonV1 = (): React.ReactElement => {
  const { classes, cx } = useStyles()

  return (
    <Box>
      <Stack direction="row" justifyContent={'space-between'} alignItems={'center'} mt={2} mb={2}>
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
        </Stack>
        <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
      </Stack>

      <Divider className={classes.divider} />

      <Stack direction="row" rowGap={2} columnGap={2} className={classes.cardStats} flexWrap="wrap">
        <Skeleton variant="rounded" height={90} width={200} className={classes.cardSkeleton} />
        <Skeleton variant="rounded" height={90} width={200} className={classes.cardSkeleton} />
        <Skeleton variant="rounded" height={90} width={200} className={classes.cardSkeleton} />
      </Stack>

      <Box className={classes.tableContainer} sx={{ pt: 2 }}>
        <Paper>
          <ApiTableSkeleton columnAmount={5} withFilter={false} />
        </Paper>
      </Box>

      <Paper sx={{ mt: 4 }}>
        <BarChartSkeleton height={400} />
      </Paper>
    </Box>
  )
}

export default EMobilityChargingSessionsSkeletonV1
